import { getShouldShowRSVP } from 'mini-mail-list-store/lib/selectors/mailListDataPropertyGetter';
import { getUserConfiguration } from 'owa-session-store';
import { shouldShowEdgeHeader } from 'bootstrap/lib/utils/shouldShowEdgeHeader';
import { DisplayCustomisations } from '../../components/VirtualizedListView/DisplayCustomisationsProvider ';

export const enum RowComponentsID {
    ListHeader = 'ListHeader',
    ExtendedListHeader = 'ExtendedListHeader',
    FocusedOtherCampaign = 'FocusedOtherCampaign',
    AutomaticReplyBanner = 'AutomaticReplyBanner',
    FocusedInboxRollup = 'FocusedInboxRollup',
    AdContainer = 'AdContainer',
    AdBannerContainer = 'AdBannerContainer',
    AdContainerExp = 'AdContainerExp',
    Spinner = 'Spinner',
    LoadError = 'LoadError',
    GreenRoom = 'GreenRoom',
}

export const RowComponentsHeight = {
    // Should be in sync with $secondaryHeaderHeight in mini-mixins.scss (height of focused/other header)
    [RowComponentsID.ListHeader]: 43,
    // Should be in sync with $extendedHeaderHeight in mini-mixins.scss
    [RowComponentsID.ExtendedListHeader]: 54 + (shouldShowEdgeHeader() ? 56 : 0),
    [RowComponentsID.FocusedOtherCampaign]: 200,
    // Should be in sync with $automaticReplyBanner in MailListItemSharedVariables.scss
    [RowComponentsID.AutomaticReplyBanner]: 48,
    // Should be in sync with $focusedInboxRollupItemHeight in MailListItemSharedVariables.scss
    [RowComponentsID.FocusedInboxRollup]: 54,
    // Should be in sync with $nativeAdPreLoadStaticContainerHeight in nativeAdItemPreLoading.scss
    [RowComponentsID.AdContainerExp]: 70,
    [RowComponentsID.AdBannerContainer]: 80,
    [RowComponentsID.AdContainer]: 80,
    [RowComponentsID.Spinner]: 30,
    [RowComponentsID.GreenRoom]: 125,
    // Should be in sync with $loadMoreErrorComponentTotalHeight (74px) && $spacerHeight (24px) in LoadMoreError.scss
    [RowComponentsID.LoadError]: 74 + 24,
};

// Should be in sync with $moduleSwitcherHeight in mini-mixins.scss
export const MODULE_SWITCHER_HEIGHT = 40;
// Should be in sync with $mailListItemHeight in nativeAdItemPreLoading.scss
export const MAIL_LIST_ITEM_HEIGHT = 70;
// Should be in sync with $mailListItemHeightWithoutPreview in nativeAdItemPreLoading.scss
export const MAIL_LIST_ITEM_HEIGHT_WITHOUT_PREVIEW = 60;
// Should be in sync with $rsvpUnitWrapperHeight in mini-mixins.scss
export const RSVP_UNIT_WRAPPER_HEIGHT = 63;
// SHould be in sync with EmbeddedCampaignMessage.scss
export const FOCUSED_OTHER_CAMPAIGN_ITEM_HEIGHT_IN_PX: number = 200;
export const MULTI_SELECT_CAMPAIGN_ITEM_HEIGHT_IN_PX: number = 80;
export const MULTI_SELECT_FOOTER_HEIGHT: number = MODULE_SWITCHER_HEIGHT;

// Height of the header area in UnifiedSearch which consist of SearchBox, Tabs and filter.
// It's a sum of true height of searchHeaderWrapper in SearchHeaderV2.scss, $tabsHeaderHeight
// in Tabs.scss and $headerBaseHeight in mini-mixins.scss
export const UNIFIED_SEARCH_HEADER_HEIGHT = 132;

const isMailItemComponent = (componentId: string) =>
    !(componentId && RowComponentsID.hasOwnProperty(componentId));

const getRichContentHeightForItem = (
    rowId?: string,
    displayCustomisations?: DisplayCustomisations
) => {
    if (!displayCustomisations?.richContentFlags) {
        return 0;
    }
    const { shouldShowRSVPUnit } = displayCustomisations.richContentFlags;
    let richContentHeight = 0;

    // 1. Add RSVPUnit height if needed
    richContentHeight +=
        shouldShowRSVPUnit && getShouldShowRSVP(rowId) ? RSVP_UNIT_WRAPPER_HEIGHT : 0;

    return richContentHeight;
};

const getListItemHeight = (
    listItemId?: string,
    displayCustomisations?: DisplayCustomisations,
    overwrites?: [string, number][]
): number => {
    if (isMailItemComponent(listItemId)) {
        const mailItemBaseHeight = getUserConfiguration().UserOptions.ShowPreviewTextInListView
            ? MAIL_LIST_ITEM_HEIGHT
            : MAIL_LIST_ITEM_HEIGHT_WITHOUT_PREVIEW;

        return mailItemBaseHeight + getRichContentHeightForItem(listItemId, displayCustomisations);
    }
    for (const tuple of overwrites) {
        const [key, overwrittenHeight] = tuple;
        if (key === listItemId) {
            return overwrittenHeight;
        }
    }
    return RowComponentsHeight[listItemId];
};

export default getListItemHeight;
